import * as angular from 'angular';
import { OutputStateCardComponent } from './outputStateCard/outputStateCard.component';
import { OutputConditionCardComponent } from './outputConditionCard/outputConditionCard.component';
import { OutputCardComponent } from './outputCard/outputCard.component';
import { DeskOutputCardComponent } from './deskOutputCard/deskOutputCard.component';
import { OutputsComponent } from './outputs/outputs.component';
import { SmartSalesOutputCardComponent } from './smartSalesOutputCard/smartSalesOutputCard.component';
import { PaymentOutputCardComponent } from './paymentOutputCard/paymentOutputCard.component';
export const outputsTabComponents = angular
    .module('outputsTabsComponents', [])
    .component('outputs', OutputsComponent)
    .component('outputStateCard', OutputStateCardComponent)
    .component('outputConditionCard', OutputConditionCardComponent)
    .component('outputCard', OutputCardComponent)
    .component('deskOutputCard', DeskOutputCardComponent)
    .component('smartSalesOutputCard', SmartSalesOutputCardComponent)
    .component('paymentOutputCard', PaymentOutputCardComponent)
    .name;
